import { render, staticRenderFns } from "./PaginationProgrammaticIncDec.vue?vue&type=template&id=3b79fa22"
import script from "./PaginationProgrammaticIncDec.vue?vue&type=script&lang=js"
export * from "./PaginationProgrammaticIncDec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports